<template>
  <div class="middle-content">
    <div id="map-blur" class="map-blur">
      <div class="map-blur-text">
        <h2 class>Redirecionando</h2>
        <p>Você está sendo redirecionado...</p>
      </div>
      <div class="map-blur-image"></div>
    </div>
    <div id="map-container" class="map-container on-left"></div>
  </div>
</template>

<script>
import { UserManager, WebStorageStateStore, User } from 'oidc-client';

var mgr = new UserManager({ response_mode: 'query', userStore: new WebStorageStateStore() });

export default {
  name: 'Redirect',

  props: {},
  data() {},
  methods: {},

  mounted() {    
    mgr
      .signinRedirectCallback()
      .then(function(user) {        
        window.location.href = '/';
      })
      .catch(function(err) {
        console.log(err);
      });
  }
};
</script>
